<template>
  <div class="cardContainer evaluationHeader">
    <b-row align-h="between">
      <b-col cols="9">
        <slot name="title" />
      </b-col>
      <b-col cols="3">
        <b-row align-h="end">
          <b-col cols="6">
            <template-status :status="status" />
          </b-col>
          <b-col cols="4">
            {{ requirement.evaluation_last_updated }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div style="margin-top: 20px">
      <slot name="description" />
    </div>
    <div style="margin-left: 0px">
      <template-requirements-path :requirement="requirement" />
    </div>
    <div>
      <slot name="additionalTemplate" />
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluationNodeInformation",
  props: ["requirement", "status"],
};
</script>

<style lang="sass" scoped>

</style>
